import { DateTime } from "luxon";
import { carwashApi_getTransactions, IReturnGetMembeship } from "../carwashApi";
import { IDailyTrackerMemberUsageTable } from "../components/DailyTrackerMemberUsage/DailyTrackerMemberUsageTable.component";
import { omit } from "lodash";

export function dailyTrackerMemberUsageTable_RemarkLogic(
  data: IDailyTrackerMemberUsageTable
) {
  const remarks = new Array<String>();
  if (
    !data.memberWasValid &&
    data.dailyTrackerMemberStatus.toUpperCase() === "INACTIVE"
  ) {
    return data;
  }

  if (
    !data.memberWasValid &&
    data.dailyTrackerMemberStatus.toUpperCase() === "NON-MEMBER"
  ) {
    return data;
  }

  if (
    data.dailyTrackerMemberStatus.toUpperCase() === "ACTIVE" &&
    !data.memberWasValid &&
    data.dailyTrackerAction.toUpperCase() === "CUCI MEMBER"
  ) {
    remarks.push("Member di System INVALID");
  }

  if (
    data.dailyTrackerMemberStatus.toUpperCase() === "ACTIVE" &&
    !data.isUsed &&
    data.dailyTrackerAction.toUpperCase() === "CUCI MEMBER"
  ) {
    remarks.push("Member tidak USED di System");
  }

  if (
    data.dailyTrackerMemberStatus.toUpperCase() === "ACTIVE" &&
    data.dailyTrackerAction.toUpperCase() === "CUCI MEMBER" &&
    data.dailyTrackerMemberNumber.toUpperCase() !==
      data.memberNumber.toUpperCase()
  ) {
    remarks.push("Member Number tidak sama di System");
  }

  if (
    data.dailyTrackerAction.toUpperCase() !== "CUCI MEMBER" &&
    data.dailyTrackerAction.toUpperCase() !== "CUCI OWNER" &&
    data.memberWasValid
  ) {
    remarks.push("Member Valid tapi tidak Cuci Member di System");
  }

  data.remark = remarks.join("\n");
  return data;
}

export async function checkHistoryMembershipValidity(
  membership: IReturnGetMembeship,
  memberNumber: String,
  date: Date
) {
  const foundMemberNumberObj = membership.membership_info_kartus?.find(
    (m) => m.nomor_kartu === memberNumber
  );
  if (!foundMemberNumberObj) return false;

  const resTransactions = await carwashApi_getTransactions({
    transaction_type: "member-cuci-unlimited",
    "memberships.membership_id": membership.membership_id,
    transaction_date_min: DateTime.fromISO(foundMemberNumberObj.created_at)
      .set({ hour: 0, minute: 0, second: 0 })
      .toFormat("yyyy-MM-dd'T'HH:mm:ss"),
    transaction_date_max: DateTime.fromISO(foundMemberNumberObj.created_at)
      .set({ hour: 23, minute: 59, second: 59 })
      .toFormat("yyyy-MM-dd'T'HH:mm:ss"),
  });
  const trxItems = resTransactions.data.data
    .map((d) =>
      d.transaction_items.map((_d) => ({
        ..._d,
        ...omit(d, ["transaction_items"]),
      }))
    )
    .flat();
  const memberTransaction = trxItems.find(
    (t) =>
      t.transaction_item_name.includes("NEW MEMBER") ||
      t.transaction_item_name.includes("EXTEND MEMBER")
  );
  if (!memberTransaction) return false;

  const duration = Number(
    memberTransaction?.transaction_item_name.match(/(\d+)/)?.[1] || 0
  );
  if (!duration) return false;

  const expireDateOfMemberNumber = DateTime.fromJSDate(
    memberTransaction.transaction_date
  )
    .plus({ month: duration })
    .minus({ day: 1 })
    .set({ hour: 23, minute: 59, second: 50 })
    .toJSDate();

  if (expireDateOfMemberNumber.getTime() <= date.getTime()) return false;

  return true;
}
